import "./AdvancedTabs.scss";
import React, { useState } from "react";
import moment from "moment";
import {
  Button,
  DatePicker,
  Input,
  Select,
  Badge,
  Tooltip,
  Tabs,
  Row,
  Col,
} from "antd";
import { useTranslation } from "react-i18next";

const AdvancedTabs = ({ cbFilters, areas, currentUser, categories }) => {
  const { Option } = Select;
  const [advancedObj, setAdvancedObj] = useState({
  });
  const [advancedObjMenu, setAdvancedObjMenu] = useState({
    m1: {},
    m2: {},
    m3: {},
    m4: {},
  });
  const { TabPane } = Tabs;
  const { t } = useTranslation();

  const handlerChange = (menu, field, value=null, enter) => {
    const normalizedValue = value ?? null;
    const obj = { ...advancedObj, [field]: normalizedValue };
    if (normalizedValue === null || normalizedValue === "") {
      delete obj[field];
    }
    setAdvancedObj(obj);
    if (enter) {
      let objMenu = advancedObjMenu[menu];
      const obj2 = { ...objMenu, [field]: normalizedValue };
      if (normalizedValue === null || normalizedValue === "") {
        delete obj2[field];
      }
      const obj3 = { ...advancedObjMenu, [menu]: obj2 };

      cbFilters(obj);
      setAdvancedObjMenu(obj3);
    }
  };

  const enterHandler = (menu, field, value) => {
    handlerChange(menu, field, value, true);
  };

  const handleClear = () => {
      setAdvancedObj({});
    setAdvancedObjMenu({ m1: {}, m2: {}, m3: {}, m4: {} });
      cbFilters({}, true);
  };

  return (
    <div className="adv-tabs-filters">
      <div className="filters-inner">
        <Tooltip title={t('messages.aml.cdi.advanced.clearFilters')}>
          <Button
            icon="delete"
            className="btn-clear"
            shape="circle"
            ghost
            onClick={handleClear}
          />
        </Tooltip>
        <Tabs>
        <TabPane
            key="1"
            tab={
              <span>
                {t('messages.aml.cdi.advanced.person')}{" "}
                <Badge count={Object.entries(advancedObjMenu.m1).length} />
              </span>
            }
        >
          <Row gutter={4}>
            <Col span={6}>
              <Select
                style={{ width: "100%" }}
                placeholder={t('messages.aml.cdi.advanced.personType')}
                allowClear
                value={advancedObj.tipoPersona}
                onChange={(value) =>
                  handlerChange("m1", "tipoPersona", value, true)
                }
              >
                <Select.Option value="Entity">
                  {t("messages.aml.entity")}
                </Select.Option>
                <Select.Option value="Person">
                  {t("messages.aml.person")}
                </Select.Option>
              </Select>
            </Col>

            <Col span={6}>
                <Select 
                  value={advancedObj.empresa}
                  style={{ width: "100%" }}
                  allowClear
                  placeholder={t('messages.aml.company')}
                  onChange={(e) =>
                    handlerChange("m1", "empresa", e, true)
                  }
                >
                  {(currentUser.empresas !== null && currentUser.empresas.length > 0) ?
                      currentUser.empresas.map( (c) => <Select.Option value={c.id}>{c.name}</Select.Option>)
                  :
                  <Select.Option value="N/A">{t('messages.aml.cdi.step2Bd.noCompanies')}</Select.Option>
                  }
                </Select>
            </Col>

            { areas &&
              <Col span={6}>
              <Select
                  style={{ width: "100%" }}
                  placeholder={t('messages.aml.cdi.advanced.area')}
                  allowClear
                  value={advancedObj.area}
                  onChange={(value) =>
                    handlerChange("m1", "area", value, true)
                  }
                >
                  {areas.map((area) => (
                      <Option value={area}>
                        {area}
                      </Option>
                    )
                  )}
                  
                </Select>
              </Col>
            }
              
          </Row>
        </TabPane>
        <TabPane
          key="2"
          tab={
            <span>
              {t('messages.aml.links')}{" "}
              <Badge count={Object.entries(advancedObjMenu.m2).length} />
            </span>
          }
        >
          <Row gutter={4}>
            {/*
            <Col span={7}>
              <Select
                style={{ width: "100%" }}
                placeholder="Tipo de Declaración"
                allowClear
                value={advancedObj.typeDeclaration}
                onChange={(value) =>
                  handlerChange("m2", "typeDeclaration", value, true)
                }
              >
                {getDeclOptions()}
              </Select>
            </Col>
            */}
            <Col span={7}>
              <Select
                style={{ width: "100%" }}
                placeholder={t('messages.aml.links')}
                allowClear
                value={advancedObj.hasMatches}
                onChange={(value) =>
                  handlerChange("m2", "hasMatches", value, true)
                }
              >
                <Option value={true}>{t('messages.aml.cdi.advanced.hasLinksYes')}</Option>
                <Option value={false}>{t('messages.aml.cdi.advanced.hasLinksNo')}</Option>
              </Select>
            </Col>
          </Row>
        </TabPane>
          <TabPane
            key="3"
            tab={
                <span>
                  {t('messages.aml.report.type.DECL')}{" "}
                  <Badge count={Object.entries(advancedObjMenu.m3).length} />
                </span>
            }
          >
            <Row gutter={4}>
              <Col span={4}>
                <Input
                    placeholder={t('messages.aml.folio')}
                    value={advancedObj.folio}
                    onChange={(e) =>
                      handlerChange("m3", "folio", e.target.value, false)
                    }
                    onPressEnter={(e) =>
                      enterHandler("m3", "folio", e.target.value)
                    }
                  />
              </Col>
              <Col span={4}>
                <Select 
                  value={advancedObj.statusDecl}
                  style={{width: "100%" }}
                  placeholder={t('messages.aml.cdi.advanced.status')}
                  allowClear
                  onChange={(value) =>
                  handlerChange("m3", "statusDecl", value, true)} 
                >
                  <Option value="PENDIENTE">{t('messages.aml.cdi.status.pending')}</Option>
                  <Option value="EVALUACION">{t('messages.aml.cdi.status.done')}</Option>
                  <Option value="AUTORIZADA">{t('messages.aml.cdi.status.authorized')}</Option>
                  <Option value="RECHAZADA">{t('messages.aml.cdi.status.rejected')}</Option>
                  <Option value="OBSERVADA">{t('messages.aml.cdi.status.observed')}</Option>
                </Select>	                      
              </Col>
              <Col span={5}>
                <DatePicker.RangePicker
                  placeholder={[t('messages.aml.cdi.advanced.requestDateFrom'), t('messages.aml.cdi.advanced.to')]}
                  style={{ width: "100%" }}
                  value={
                    advancedObj.sendDate
                      ? [
                          moment(advancedObj.sendDate[0]),
                          moment(advancedObj.sendDate[1]),
                        ]
                      : null
                        }
                  onChange={(momentObj) =>
                    handlerChange(
                      "m3",
                      "sendDate",
                      momentObj !== null && momentObj.length > 0
                        ? [
                            moment(momentObj[0]).valueOf(),
                            moment(momentObj[1]).valueOf(),
                          ]
                        : null,
                      true
                    )
                  }
                />
              </Col>
              <Col span={5}>
                <DatePicker.RangePicker
                  placeholder={[t('messages.aml.cdi.advanced.doneDateFrom'), t('messages.aml.cdi.advanced.to')]}
                  style={{ width: "100%" }}
                  value={
                    advancedObj.completeDate
                      ? [
                          moment(advancedObj.completeDate[0]),
                          moment(advancedObj.completeDate[1]),
                        ]
                      : null
                        }
                  onChange={(momentObj) =>
                    handlerChange(
                      "m3",
                      "completeDate",
                      momentObj !== null && momentObj.length > 0
                        ? [
                            moment(momentObj[0]).valueOf(),
                            moment(momentObj[1]).valueOf(),
                          ]
                        : null,
                      true
                    )
                  }
                />
              </Col>
              <Col span={6}>
                <DatePicker.RangePicker
                  placeholder={[t('messages.aml.cdi.advanced.lastReminderFrom'), t('messages.aml.cdi.advanced.to')]}
                  style={{ width: "100%" }}
                  value={
                    advancedObj.lastReminder
                      ? [
                          moment(advancedObj.lastReminder[0]),
                          moment(advancedObj.lastReminder[1]),
                        ]
                      : null
                        }
                  onChange={(momentObj) =>
                    handlerChange(
                      "m3",
                      "lastReminder",
                      momentObj !== null && momentObj.length > 0
                        ? [
                            moment(momentObj[0]).valueOf(),
                            moment(momentObj[1]).valueOf(),
                          ]
                        : null,
                      true
                    )
                  }
                />
              </Col>
            </Row>
          </TabPane>

          <TabPane
            key="4"
            tab={
              <span>
                {t('messages.aml.cdi.advanced.comments')}{" "}
                <Badge count={Object.entries(advancedObjMenu.m4).length} />
              </span>
            }
          >
            <Row gutter={4}>
              <Col span={7}>
                <Select
                  style={{ width: "100%" }}
                  placeholder={t('messages.aml.cdi.advanced.comments')}
                  allowClear
                  value={advancedObj.hasComments}
                  onChange={(value) =>
                    handlerChange("m4", "hasComments", value, true)
                  }
                >
                  <Option value="YES">{t('messages.aml.cdi.advanced.hasCommentsYes')}</Option>
                  <Option value="NO">{t('messages.aml.cdi.advanced.hasCommentsNo')}</Option>
                </Select>
              </Col>
            </Row>
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default AdvancedTabs;
